import { FRETS_0_12, masteryAchievement } from './helpers';

export default masteryAchievement({
  id: 'string-5-master',
  title: 'String 5 master',
  description: `You know every natural note on the A string, ${FRETS_0_12}.`,
  order: 20,
  skillId: 'F2.string5-naturals',
});
